import { Component } from "@angular/core";
import { PlanOfCareDataService } from "../../../providers/poc-data-service/poc-data-service";

@Component({
  selector: "patient-brief",
  templateUrl: "patient-brief.html",
})
export class PatientBriefComponent {
  patientBrief: any = {};

  constructor(private dataService: PlanOfCareDataService) {
    this.dataService.getPatientBriefData().subscribe(
      (data) => {
        this.patientBrief["patientFullName"] = data["patientFullName"];
        this.patientBrief["age"] = data["age"];

        if (data["patientGender"] === "M") {
          this.patientBrief["patientGender"] = "Male";
        } else if (data["patientGender"] === "F") {
          this.patientBrief["patientGender"] = "Female";
        }

        this.patientBrief["levelOfCare"] = data["levelOfCare"];
        this.patientBrief["riskPriority"] = data["riskPriority"];
        this.patientBrief["codeStatus"] = data["codeStatus"];
        this.patientBrief["primaryDiagnosis"] = data["primaryDiagnosis"];
      },

      (err) => {
        // console.error(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/patient-brief/patient-brief.ts